import React from 'react';
import Button from '../../Components/Button';
import PageDetails from './PageDetails';
import PageElements from './PageElements';
import { BuilderActionType, BuilderContext } from './state';
import { PageType } from '../../Model/PageData';
import PageSelector from './PageSelector';

function Workspace() {
    const { dispatch, state } = React.useContext(BuilderContext);
    const { previewPage } = state;

    const handleRemove = () => {
        dispatch({
            type: BuilderActionType.DELETE_PREVIEW_PAGE,
        });
    };

    if (!previewPage) {
        return null;
    }
    return (
        <div
            className="flex w-full flex-col gap-4 overflow-x-hidden overflow-y-auto px-5 py-6"
            style={{
                maxWidth: '56%',
                minWidth: '620px',
            }}
        >
            <PageSelector />
            <PageDetails />
            <PageElements />
            {previewPage.id !== PageType.SCREEN_DEFAULT && (
                <Button
                    onClick={handleRemove}
                    className="bg-primary-light text-white normal-case"
                >
                    Remove page
                </Button>
            )}
        </div>
    );
}
export default Workspace;
